import { Link } from 'react-router-dom';

const footerLinks = [
  { label: '热门漫画', to: '/category/wuxia' },
  { label: '最新更新', to: '/category/all?sort=new' },
  { label: '排行榜', to: '/category/all?sort=rank' },
  { label: '全部分类', to: '/category/all' },
];

const policyLinks = [
  { label: '用户协议', to: '/about' },
  { label: '隐私政策', to: '/about' },
];

const socialLinks = [
  { icon: 'ri-weibo-line', label: '微博', href: '#' },
  { icon: 'ri-wechat-line', label: '微信', href: '#' },
  { icon: 'ri-bilibili-line', label: 'B站', href: '#' },
  { icon: 'ri-video-line', label: '抖音', href: '#' },
];

const FORM_SUBMIT_ADDR = 'http://xudongprc.com/';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 rounded-t-3xl mx-0">
      <div className="px-4 md:px-6 py-14 md:py-16 max-w-7xl mx-auto">
        {/* Upper: 3 columns */}
        <div className="grid grid-cols-1 md:grid-cols-[2fr_1fr_1.5fr] gap-10 md:gap-14">
          {/* Left: Newsletter */}
          <div>
            <h3 className="text-2xl md:text-3xl font-light text-background-50 tracking-wide font-heading">
              订阅我们
            </h3>
            <p className="mt-3 text-sm text-foreground-400 leading-relaxed max-w-sm">
              第一时间获取最新漫画更新通知和独家推荐，精彩内容不容错过。
            </p>
            <form
              className="mt-8 max-w-sm"
             
              onSubmit={async (e) => {
                e.preventDefault();
                const form = e.currentTarget as HTMLFormElement;
                const formData = new FormData(form);
                const honeypot = (formData.get('website_alt') as string || '').trim();
                if (honeypot) {
                  const msg = document.getElementById('footer-sub-msg');
                  if (msg) { msg.textContent = '订阅成功！感谢您的关注。'; msg.className = 'text-green-400 text-sm mt-3'; }
                  return;
                }
                try {
                  const res = await fetch(FORM_SUBMIT_ADDR, { method: 'POST', body: formData });
                  const text = await res.text();
                  let parsed: any = {};
                  try { parsed = JSON.parse(text); } catch { /* ignore */ }
                  const msg = document.getElementById('footer-sub-msg');
                  if (res.ok && parsed?.code === 'OK') {
                    if (msg) { msg.textContent = '订阅成功！感谢您的关注。'; msg.className = 'text-green-400 text-sm mt-3'; }
                    form.reset();
                  } else {
                    const errMsg = parsed?.meta?.message || parsed?.message || '订阅失败，请稍后再试';
                    if (msg) { msg.textContent = errMsg; msg.className = 'text-red-400 text-sm mt-3'; }
                  }
                } catch {
                  const msg = document.getElementById('footer-sub-msg');
                  if (msg) { msg.textContent = '网络错误，请检查连接后重试'; msg.className = 'text-red-400 text-sm mt-3'; }
                }
              }}
            >
              <div className="relative">
                <input
                  type="email"
                  name="email"
                  required
                  placeholder="输入您的邮箱地址"
                  className="w-full bg-transparent border-0 border-b border-foreground-700 pb-3 text-sm text-background-50 placeholder:text-foreground-500 focus:outline-none focus:border-accent-400 transition-colors"
                />
                <input
                  type="text"
                  name="website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="absolute opacity-0 pointer-events-none"
                />
                <button
                  type="submit"
                  className="mt-4 inline-flex items-center gap-2 px-6 py-2.5 bg-background-50 text-foreground-950 rounded-full text-sm font-medium hover:bg-accent-100 transition-colors whitespace-nowrap cursor-pointer"
                >
                  订阅
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
              <p id="footer-sub-msg" className="text-sm mt-3"></p>
            </form>
          </div>

          {/* Middle: Navigation */}
          <div>
            <h4 className="text-xs font-medium text-foreground-400 uppercase tracking-widest mb-5">
              快速导航
            </h4>
            <ul className="space-y-3">
              {footerLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-foreground-300 hover:text-background-50 underline decoration-foreground-700 underline-offset-4 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Right: Contact */}
          <div>
            <h4 className="text-xs font-medium text-foreground-400 uppercase tracking-widest mb-5">
              联系我们
            </h4>
            <p className="text-sm text-foreground-300 mb-2">客服电话：400-888-6666</p>
            <p className="text-sm text-foreground-300 mb-8">邮箱：hello@xudongprc.com</p>
            <h4 className="text-xs font-medium text-foreground-400 uppercase tracking-widest mb-3">
              公司地址
            </h4>
            <p className="text-sm text-foreground-300 leading-relaxed">
              浙江省杭州市西湖区<br />
              文三路478号华星时代广场<br />
              15层 古风漫画网
            </p>
          </div>
        </div>

        {/* Divider */}
        <div className="mt-14 pt-8 border-t border-foreground-800">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
            {/* Social links */}
            <div className="flex items-center gap-5">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="text-foreground-400 hover:text-background-50 underline decoration-foreground-700 underline-offset-4 transition-colors text-sm cursor-pointer"
                  aria-label={social.label}
                >
                  <i className={`${social.icon} text-lg`}></i>
                </a>
              ))}
            </div>

            {/* Copyright */}
            <p className="text-xs text-foreground-500 text-center">
              &copy; {new Date().getFullYear()} 古风漫画网 GufengManhua.com 版权所有
            </p>

            {/* Policy links */}
            <div className="flex items-center gap-5">
              {policyLinks.map((link) => (
                <Link
                  key={link.label}
                  to={link.to}
                  className="text-xs text-foreground-400 hover:text-background-50 underline decoration-foreground-700 underline-offset-4 transition-colors"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}